import {Component} from 'substance'
import {mapKeyToSymbol} from '../../../../lib/utils/mapKeyToSymbol'

/**
 * @typedef Component.KBDKeyComboComponent.Props
 * @property {string} keyCombo - The key combination to render. E.g. 'Cmd+Shift+X'
 */

/**
 * Simple stateless component to render a key combination as <KDB> elements
 *
 * @class KBDKeyComboComponent
 * @param {Component.KBDKeyComboComponent.Props} props
 * @property {Component.KBDKeyComboComponent.Props} props
 */
class KBDKeyComboComponent extends Component {

    render($$) {
        return $$('div', {class: 'keybinding-kbd-container'},
            this.props.keyCombo.split('+').map(part => {
                return $$('kbd', null, mapKeyToSymbol(part))
            })
        )
    }
}

export {KBDKeyComboComponent}
